export default {
  text: {
    fontFamily: 'Graphik LCG',
    fontSize: 9,
    lineHeight: 1.5,
    marginBottom: 12,
    wordWrap: 'break-word',
  },
};
